export default "__VITE_ASSET__Bxe9VyIQ__"